import { isBefore, parseISO, subMinutes } from "date-fns";

export const isMoreThanXMinutesAgo = (dateString: string, minutes: number) => {
  const date = parseISO(dateString); // parses ISO string to Date
  const fiveMinutesAgo = subMinutes(new Date(), minutes);
  return isBefore(date, fiveMinutesAgo);
};
